module.exports = __webpack_public_path__ + "media/images/pc/inbound_guidance/close-da4e89cc14a4402395aa7a071ef95dac.svg";